import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { SnAbilityService } from '@lib/ability';
import { SnUser } from '@lib/api/entities';
import { SnUsersAPI } from '@lib/api/services';
import { snListStagger, snFadeIn, snFadeOut } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-user-table',
  templateUrl: './user-table.component.html',
  styleUrls: ['./user-table.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut],
})
export class UserTableComponent extends SnTableBaseComponent<SnUser> implements OnInit, OnDestroy {
  @Input()
  public selection: SelectionModel<SnUser>;
  public userAbilities: any;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _usersAPI: SnUsersAPI,
    private readonly _ability: SnAbilityService,
    private readonly _cd: ChangeDetectorRef,
  ) {
    super();
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public unlockUser(user: SnUser): void {
    if (this._ability.can({ subject: 'users/user', action: ['change'] })) {
      this._usersAPI
        .unlockProfile(user.id)
        .pipe(takeUntil(this._destroy$))
        .subscribe((response) => {
          if (response) {
            user.isLocked = false;
          }
          this._cd.detectChanges();
        });
    }
  }

  public trackBy(index: number, item: SnUser): string {
    return item.id;
  }

  public masterToggle(): void {
    this.isAllSelected() ? this.selection.clear() : this.selection.select(...this.items);
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.items.length;

    return numSelected === numRows;
  }
}
